// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"_1DBKQ","errorLabel":"_2SQm3"};